<template>
  <div>
    <BBPSelectTag
      :options="input.options"
      :values="value"
      @change="setValue"
    />
  </div>
</template>

<script>
import BBPSelectTag from '@/components/Main/InputFields/BBPSelectTag/BBPSelectTag'
import {get, set} from 'lodash'

export default {
  name: 'BBPSelectTagInput',
  components: {BBPSelectTag},
  props: ['input', 'model'],
  computed: {
    value () {
      const value = get(this.model, this.input.model, '')
      return value
    }
  },
  methods: {
    setValue (val) {
      set(this.model, this.input.model, val)
      this.$emit('input', val, this.input)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPSelectTagInput/BBPSelectTagInput.vue